import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M21 8H3V4h18v4zm0 2H3v4h18v-4zm0 6H3v4h18v-4z"
}), 'TableRows');